import type { SupportRequestRow } from '@pqrs/contracts';
import { Badge } from '@xiltrion/ui/badge';
import { Icono } from '@xiltrion/ui/icono';
import { Item, ItemActions, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@xiltrion/ui/item';
import { fmtDate } from '@/components/ui';
import { useSupportRequests } from './api';

/** Los apoyos que le toca responder a la persona (pendientes de sus áreas): se listan como tareas. */
export const usePendingSupport = () => useSupportRequests({ box: 'inbox', status: 'PENDING' });

/**
 * Un apoyo por responder como fila de «Mis tareas», con la misma forma que `TaskRow`: abre el expediente en su pestaña
 * «Apoyos», donde se responde. No tiene vencimiento propio: muestra el del caso.
 */
export function SupportTaskRow({ r, onOpen }: { r: SupportRequestRow; onOpen: () => void }) {
  return (
    <li>
      <Item asChild size="sm" className="w-full flex-nowrap gap-3 py-2 px-1 text-left cursor-pointer hover:bg-accent">
        <button type="button" onClick={onOpen} aria-label={`Responder apoyo de ${r.targetUnit.name} · ${r.case.radication ?? ''}`}>
          <ItemMedia aria-hidden className="text-base w-6 text-warning"><Icono nombre="mdi:account-multiple-outline" /></ItemMedia>
          <span className="w-44 shrink-0">
            <span className="text-xs text-muted-foreground block tnum">{r.case.radication ?? '—'}</span>
            <span className="text-xs text-muted-foreground">{r.case.caseTypeName}</span>
          </span>
          <ItemContent className="min-w-0 gap-0">
            <ItemTitle className="w-full"><span className="truncate">Responder apoyo · {r.targetUnit.name}</span></ItemTitle>
            <ItemDescription className="line-clamp-1 text-[13px]">{r.case.subject} · De {r.requestedBy.name}</ItemDescription>
          </ItemContent>
          <ItemActions className="gap-3">
            <span className="hidden md:inline"><Badge variant="warning-light" size="sm">Apoyo</Badge></span>
            <span className="w-40 text-right text-[13px] text-muted-foreground tnum">{r.case.dueAt ? `Caso vence ${fmtDate(r.case.dueAt)}` : 'Sin fecha límite'}</span>
          </ItemActions>
        </button>
      </Item>
    </li>
  );
}
